import { gql } from '@apollo/client';

const TableSettingsFragment = gql`fragment TableSettings on CompanyTableSettingsDTO {
	culture
	fields {
		field
		label
		settings
		__typename
	}
}`;

export default TableSettingsFragment;